<template>
  <div class="flex items-center">
    <button
      type="button"
      :class="[
        modelValue ? 'bg-primary' : 'bg-background-fg/50',
        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent ring-offset-background transition-colors duration-200 ease-in-out disabled:pointer-events-none',
      ]"
      role="switch"
      aria-checked="false"
      :disabled="disabled"
      @click="emit('update:modelValue', !modelValue)"
    >
      <span
        aria-hidden="true"
        :class="[
          modelValue ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block size-5 rounded-full bg-background shadow ring-0 transition duration-200 ease-in-out',
        ]"
      />
    </button>

    <span class="ml-3">
      <span class="text-sm font-medium text-background-fg">
        <slot name="label">{{ label }}</slot>
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string
  modelValue: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()
</script>
